var map = {
	"./sticker-0-0--1.svg": "4202",
	"./sticker-0-0.svg": "d50a",
	"./sticker-0-1.svg": "273b",
	"./sticker-0-2.svg": "5e69",
	"./sticker-0-4.svg": "06da",
	"./sticker-0-5.svg": "b803",
	"./sticker-0-6.svg": "b595",
	"./sticker-0-7.svg": "78fe",
	"./sticker-0-8.svg": "9ddd",
	"./sticker-1-0.svg": "3541",
	"./sticker-1-1.svg": "9f44",
	"./sticker-1-2.svg": "dae6",
	"./sticker-2-0.svg": "8ad5",
	"./sticker-2-1.svg": "2aad",
	"./sticker-2-2.svg": "c15c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79b3";